// 登入註冊, 使用者帳戶管理
import axios from 'axios'
import firebase from 'firebase/app'
import {API_URL, userStatus, nodeId,sourceTree} from './config.js'
import initRemodal from './libs/jquery.remodal.js'
import { isNull, isUndefined } from 'util';

const providerFacebook = new firebase.auth.FacebookAuthProvider()
const providerGoogle = new firebase.auth.GoogleAuthProvider()
export default {
  loginFacebook: function () {
    let myThis = this
    firebase.auth().signInWithPopup(providerFacebook).then((result) => {
      this.checkUser().then(response => {
        if(!myThis.user.emailVerified){
          myThis.userStage = userStatus.emailValidate
          myThis.sendEmailVerification(myThis.user).then(function(sended){
            myThis.redirectTo(location.pathname + location.search)
          })
        }else{
          myThis.redirectTo(location.pathname + location.search)
        }
      })
    }).catch(function (e) {
      console.log(e)
      if(e.code == 'auth/account-exists-with-different-credential'){
        //若EMail重複
        console.log(e)
        myThis.fbCheck.email = e.email
        myThis.fbCheck.credential = e.credential;
        window.location.hash = "notice3"
      }
    })
  },
  loginGoogle: function () {
    firebase.auth().signInWithPopup(providerGoogle).then((result) => {
      this.checkUser().then(response => {
        this.redirectTo(location.pathname + location.search)
      })
    }).catch(function (e) {
      if(e.code == 'auth/account-exists-with-different-credential'){
        alert("此帳號已被註冊過！")
      }
    })
  },
  loginCheck: function(){
    return this.isLogin;
  },
  loginNormal: function (email, password) {
    console.log('login')
    const thisItem = this
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then((result) => {
      let loginEmail = email || this.login.email
      let loginPassword = password || this.login.password
      return firebase.auth().signInWithEmailAndPassword(loginEmail, loginPassword).then((result) => {
        firebase.auth().currentUser.getIdToken(true).then(function(token){
          thisItem.redirectTo(location.pathname + location.search)
        })
      }).catch(function (e) {
        console.log(e)
        if(e.code == "auth/wrong-password"){
          alert("登入失敗：密碼錯誤")
        }else{
          alert("登入失敗：帳號錯誤或尚未註冊")
        }
      })
    }).catch(function (e) {
      // Handle Errors here.
      // var errorCode = error.code;
      // var errorMessage = error.message;
      alert(e.response.data.Errors[0].Message.message)
    })
    // firebase.auth().signInWithEmailAndPassword(this.login.email, this.login.password).then(function (result) {
    //   console.log(result)
    //   this.user = result.user
    //   this.isLogin = true
    //   this.getAccessToken()
    // }).catch(function (e) {
    //   // Handle Errors here.
    //   // var errorCode = error.code;
    //   // var errorMessage = error.message;
    //   // console.log(e)
    //   alert(e.response.data.Errors[0].Message.message)
    //   // ...
    // })
  },
  sendEmailVerification: function (user) {
    return new Promise((resolve, reject) => {
        var r = confirm("請進行E-Mail驗證信認證，是否發送驗證信？");
        if (r == true) {
          user.sendEmailVerification().then(function (result) {
            // Email sent.
            resolve(true)
            console.log('sendEmailVerification')
          }).catch(function (e) {
            // An error happened.
            alert(e.response.data.Errors[0].Message)
            resolve(false)
          })
        } else {
          resolve(false)
        }
      }).catch(e => {
        console.log(e)
        reject(e)
      })
  },
  //0918火力修改
  sendPasswordResetEmail: function (emailAddress) {
    if (!emailAddress) { alert('你沒有輸入信箱，請輸入信箱，在按下忘記密碼')}
    firebase.auth().sendPasswordResetEmail(emailAddress).then(function (result) {
      // Email sent.
      console.log('sendPasswordResetEmail')
      alert('已寄出忘記密碼郵件，請去信箱重置密碼。')
    }).catch(function (e) {
      // An error happened.
      alert(e.response.data.Errors[0].Message)
    })
  },
  deleteAccount: function (user) {
    user.delete().then(function () {
      // User deleted.
      console.log('deleteAccount')
    }).catch(function (e) {
      // An error happened.
      alert(e.response.data.Errors[0].Message)
    })
  },
  loginNormalFirst: function (email, password) {
    console.log('login first')
    const thisItem = this
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then((result) => {
      let loginEmail = email || this.login.email
      let loginPassword = password || this.login.password
      return firebase.auth().signInWithEmailAndPassword(loginEmail, loginPassword).then((result) => {
        firebase.auth().currentUser.sendEmailVerification().then(function (result) {
          // Email sent.
          console.log('sendEmailVerification')
          alert("已寄送驗證信，請驗證信箱便於繼續瀏覽！")
          firebase.auth().currentUser.updateProfile({
            displayName:"y"
          }).then(function(){
            firebase.auth().currentUser.getIdToken(true).then(function(token){
              // thisItem.userStage = userStatus.emailValidate
              thisItem.redirectTo(location.pathname + location.search)
            })
          })
        }).catch(function (e) {
          // An error happened.
          alert(e.response.data.Errors[0].Message)
        })
      }).catch(function (e) {
        if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
      })
    }).catch(function (e) {
      alert(e.response.data.Errors[0].Message.message)
    })
  },
  goToRegister: function () {
    if (this.isThirdParty) { //第三方
      this.registerAccount()
    } else {
      this.registerAccountWithEmail()
    }
  },
  registerAccount: function () {
    console.log('register from third party')
    if (this.checkName() && this.checkBirth() && this.checkSex() && this.checkAgree()) {
      let params = {
        NickName: this.register.nickName,
        Birthday: this.register.birthYear + '/' + this.register.birthMonth + '/' + this.register.birthDay,
        Sex: this.register.sex// || true
      }
      axios.post(`${API_URL}/Reg/RegS1`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
        // JSON responses are automatically parsed.
        window.location.hash = ""
        this.checkUser()
      }).catch(e => {
        console.log(e)
        // this.errors.push(e)
        alert(e.response.data.Errors[0].Message)
        this.redirectTo(`${window.location.origin}`)
      })
    }
  },
  registerAccountWithEmail: function () {
    console.log('register with email')
    // this.sendPasswordResetEmail('wilson20120311@gmail.com')
    if (this.checkEmail() && this.checkPassword() && this.isSameWithConfirmPassword() && this.checkName() && this.checkBirth() && this.checkSex() && this.checkAgree()) {
      let params = {
        Email: this.register.email,
        Password: this.register.password,
        NickName: this.register.nickName,
        Birthday: this.register.birthYear + '/' + this.register.birthMonth + '/' + this.register.birthDay,
        Sex: this.register.sex
      }
      axios.post(`${API_URL}/Reg/Singup`, this.getBodyFormData(params)).then(response => {
        // JSON responses are automatically parsed.
        this.register.first = true
        this.loginNormalFirst(this.register.email, this.register.password)
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
        alert(e.response.data.Errors[0].Message)
      })

      // firebase.auth().createUserWithEmailAndPassword(email, password).catch(function(e) {
      //   // Handle Errors here.
      //   var errorCode = error.code;
      //   var errorMessage = error.message;
      //   // ...
      // });
    }
  },
  registerAccountForDetail: function () {
    let register_btn = $("#rigister_btn")
    register_btn.attr("disabled",true)
    register_btn.text("註冊中")
    if (this.checkFirstName() &&
        this.checkLastName() &&
        this.checkCountry() &&
        this.checkUniId() &&
        this.checkCountryCode() &&
        this.checkPhoneNumber() &&
        this.checkAddress()) {
      let params = {
        Name: `${this.register.lastname}${this.register.firstname}`,
        IDNo: this.register.idno,
        Mobile: `${this.register.countrycode} ${this.register.mobile}`,
        Country: `${this.register.country}`,
        City:`${this.register.country=="台灣"? this.register.city:"無"}`,
        District:`${this.register.country=="台灣"? this.register.area:"無"}`,
        Address:`${this.register.country=="台灣"? this.register.address:"無"}`
      }
      axios.post(`${API_URL}/Account/RegS2`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
        if(response.data.Errors.length){
          alert(response.data.Errors[0].Message)
          register_btn.attr("disabled",false)
          register_btn.text("填好填滿拿紅利")
        }else{
          this.redirectTo('/')
        }
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
        alert(e.response.data.Errors[0].Message)
        register_btn.attr("disabled",false)
        register_btn.text("填好填滿拿紅利")
      })

      // firebase.auth().createUserWithEmailAndPassword(email, password).catch(function(e) {
      //   // Handle Errors here.
      //   var errorCode = error.code;
      //   var errorMessage = error.message;
      //   // ...
      // });
    }else{
      register_btn.attr("disabled",false)
      register_btn.text("填好填滿拿紅利")
    }
  },
  logout: function () {
    firebase.auth().signOut().then((result) => {
      // Sign-out successful.
      console.log('logout success!')
      this.user = undefined
      this.isLogin = false
      this.$cookie.delete('token') //0918火力新增
      this.redirectTo(location.pathname + location.search + location.hash)
    }).catch(function (e) {
      // An error happened.
      alert(e.response.data.Errors[0].Message)
    })
  },
  getCities: function () {
    if(this.loginCheck()){
      return new Promise((resolve, reject) => {
        axios.get(`${API_URL}/PostAddress/CityList`, this.getBearerToken()).then(response => {
          // JSON responses are automatically parsed.
          // console.log(response)
          this.cities = response.data
          resolve(response)
        }).catch(e => {
          console.log(e)
          // this.errors.push(e)
          reject(e)
          // alert(e.response.data.Errors[0].Message)
        })
      })
    }
  },
  getCountries: function (City) {
    let params = {
      City: City
    }
    axios.get(`${API_URL}/PostAddress/DistrictList${this.getParams(params)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      this.countries[City] = response.data
      // console.log(response)
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  getCurrentUserInfo: function () {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/Account/Me`, this.getBearerToken()).then(response => {
        // JSON responses are automatically parsed.
        console.log('getCurrentUserInfo success')
        // console.log(response)
        this.userInfo = response.data
        resolve(response)
      }).catch(e => {
        console.log('getCurrentUserInfo fail')
        console.log(e)
        // fake userInfo
        this.userInfo = {ID: 1, nickName: 'Apple', avatarURL: '', mobile: '0912345678'}
        // this.errors.push(e)
        // alert(e.response.data.Errors[0].Message)
        reject(e)
      })
    })
  },
  getUserInfo: function () {
    axios.get(`${API_URL}/Account/UserInfo`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      this.userMoreInfo = response.data
    }).catch(e => {
      console.log(e)
      this.userMoreInfo = {
        NickName: 'foobar',
        Mobile: '0912345678',
        IDNo: '1234567',
        Name: 'foobarfoo',
        Birthday: '79/08/21',
        Sex: 'Female',
        Address: '台北市中正區重慶南路一段122號'
      }
      // this.errors.push(e)
      // alert(e.response.data.Errors[0].Message)
    })
  },
  getUserComments: function (sortType = 3, page = 1) {
    let params = {
      sortType: sortType,
      page: page
    }
    axios.get(`${API_URL}/Comment/GetUserComments${this.getParams(params)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // alert(e.response.data.Errors[0].Message)
    })
  },
  getUserAddress: function () {
    axios.get(`${API_URL}/Account/GetAddress`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      // console.log(response)
      this.userAdress = response.data
    }).catch(e => {
      console.log(e)
      this.userAdress = '台北市中正區重慶南路一段122號'
      // this.errors.push(e)
      // alert(e.response.data.Errors[0].Message)
    })
  },
  getUserWallet: function () {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/Account/Wallet`, this.getBearerToken()).then(response => {
        // JSON responses are automatically parsed.
        this.wallet.bouns = response.data.Bonus_Coin
        this.wallet.coin = response.data.TongLi_Coin
        resolve(response)
      }).catch(e => {
        console.log(e)
        // this.errors.push(e)
        // alert(e.response.data.Errors[0].Message)
        reject(e)
      })
    })
  },
  checkNotify(){
    if(this.checkIsLogin()){
      axios.get(`${API_URL}/Notify`, this.getBearerToken()).then(response => {
        this.IsMailNotify = response.data.IsMailNotify
        this.IsSubscribeNotify = response.data.IsSubscribeNotify
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
      })
    }
  },
  getUserTongLiCoinTradeLog: function () {
    let params = {
      Page: 1
    }
    axios.get(`${API_URL}/Account/TongLiCoin_TradeLog/${this.getParams(params)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      console.log(response)
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  getUserOrderInfo: function () {
    let params = {
      OrderSN: '1'
    }
    axios.get(`${API_URL}/Account/OrderInfo/${this.getParams(params)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  getUserBonusCoinWallet: function () {
    axios.get(`${API_URL}/Account/BonusCoinWallet`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // alert(e.response.data.Errors[0].Message)
    })
  },
  getUserBonusCoinTradeLog: function () {
    let params = {
      page: 1
    }
    axios.get(`${API_URL}/Account/BonusCoin_TradeLog/${this.getParams(params)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  showEditPassword: function () {
    this.profile.isPasswordEdit = !this.profile.isPasswordEdit
  },
  editUserPassword: function () {
    let newPwd = this.info.NewPassword
    let newPwd2 = this.info.NewPassword2
    let oldPwd = this.info.OldPassword
    // let pattern = /^(?=.*[a-zA-Z]+)(?=.*[0-9]+)[a-zA-Z0-9]+$/
    let thisItem = this
    var user = firebase.auth().currentUser;
    if(newPwd === newPwd2){
      if(newPwd.length >=6){
        switch(this.isThirdParty){
          case "facebook.com":
            firebase.auth().signInWithPopup(providerFacebook).then(function(result) {
              user = result.user;
              user.updatePassword(newPwd).then(function() {
                alert("修改密碼成功！")
                thisItem.showEditPassword()
              }).catch(function(error) {
                alert(error)
              });
            }).catch(function(error) {
              console.log(error)
            });
          break;
          case "google.com":
          case "password":
            var cred = firebase.auth.EmailAuthProvider.credential(sourceTree.user.email, oldPwd);
            user.reauthenticateAndRetrieveDataWithCredential(cred).then(function(){
              user.updatePassword(newPwd).then(function() {
                alert("修改密碼成功！")
                thisItem.showEditPassword()
              }).catch(function(error) {
                alert(error)
              });
            }).catch(function(error){
              alert("舊密碼輸入錯誤")
            })
          break;
          default:
          alert("請重新登入")
        }
      }else{
        alert('密碼至少6個字元')
      }
    }else{
      alert("新密碼與確認密碼輸入不同！")
    }
  },
  showEditAddress: function () {
    this.profile.isAddressEdit = !this.profile.isAddressEdit
  },
  editUserAddress: function (address) {
    console.log('editUserAddress')
    let params = {
      Address: address
    }
    axios.post(`${API_URL}/Account/EditAddress`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
      this.showEditAddress()
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  editUserAvatar: function (name, file) {
    console.log('editUserAvatar')
    // console.log(this.register)
    let params = {
      file: file
    }
    // console.log(params)
    axios.post(`${API_URL}/Account/EditAvatar`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
      this.info.editUserAvatar = file.name

    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  showEditNickName: function () {
    this.profile.isNickNameEdit = !this.profile.isNickNameEdit
  },
  editUserNickName: function () {
    console.log('editUserAvatar')
    // console.log(this.register)
    let params = {
      OldNick: this.info.OldNick,
      NewNick: this.info.NewNick
    }
    // console.log(params)
    axios.post(`${API_URL}/Account/EditNickName`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
      this.showEditNickName()
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  showEditMobile: function () {
    this.profile.isMobileEdit = !this.profile.isMobileEdit
  },
  editUserMobile: function () {
    console.log('editUserMobile')
    // console.log(this.register)
    let params = {
      OldMobile: this.info.OldMobile,
      NewMobile: this.info.NewMobile
    }
    if(this.info.NewMobile.length===10){
      // console.log(params)
      axios.post(`${API_URL}/Account/EditMobile`, this.getBodyFormData(params), this.getBearerToken()).then(response => {
        this.showEditMobile()
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
        alert(e.response.data.Errors[0].Message)
      })
    }else{
      alert("手機號碼長度異常！")
    }
  },
  // helper function
  checkAgree: function () {
    return (this.register.isAgree) ? true : alert('請同意條款')
  },
  checkEmail: function () {
    return (this.register.email) ? true : alert('請輸入 Email')
  },
  checkName: function () {
    return (this.register.nickName && this.register.nickName.trim().length && this.register.nickName.trim().length < 20) ? true : alert('暱稱限20個字元內')
  },
  checkBirth: function () {
    return (this.register.birthYear !== 1 && this.register.birthMonth !== 1 && this.register.birthDay !== 1) ? true : alert('請選擇正確的出生月日')
  },
  checkSex: function () {
    return (typeof this.register.sex !== 'undefined') ? true : alert('請選擇你的性別！')
  },
  checkFirstName: function () {
    return (typeof this.register.firstname !== 'undefined') ? true : alert('請輸入你的名字！')
  },
  checkLastName: function () {
    return (typeof this.register.lastname !== 'undefined') ? true : alert('請輸入你的姓氏！')
  },
  checkUniId: function () {
      if (this.register.country == '台灣') {
          return (typeof this.register.idno !== 'undefined' && this.register.idno.match(/^[A-Z]{1}[1-2]{1}[0-9]{8}$/)) ? true : alert('請輸入正確的身分證字號！')
      } else {
          return true
      }
  },
  checkCountryCode: function () {
    return (typeof this.register.countrycode !== 'undefined') ? true : alert('請選擇正確的國碼！')
  },
  checkPhoneNumber: function () {
    return (typeof this.register.mobile !== 'undefined') ? true : alert('請輸入正確的電話號碼！')
  },
  checkCountry: function () {
    return (typeof this.register.country !== 'undefined') ? true : alert('請輸入地址！')
  },
  checkAddress: function () {
      if (this.register.country == '台灣') {
          return (typeof this.register.city !== 'undefined' && typeof this.register.area !== 'undefined' && typeof this.register.address !== 'undefined') ? true : alert('請輸入地址！')
      } else {
          return true
      }
  },
  checkPassword: function () {
    // let pattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,18}$/
    return (this.register.password && this.register.password.length >= 6) ? true : alert('密碼限6個字元')
  },
  isSameWithConfirmPassword: function () {
    return (this.register.password === this.register.comfirmPassword) ? true : alert('確認密碼與密碼不同')
  },
  checkUser: function (result) {
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          let myThis = this
          firebase.auth().currentUser.reload().then(function(){
            user.getIdToken(false)
            myThis.user = user
            if(user.isAnonymous){
              myThis.isLogin = false
              myThis.logout()
            }else{
              myThis.isLogin = true
              myThis.isThirdParty = user.providerData[0].providerId
              myThis.isAuthChecked = true
            }
            myThis.getAccessToken().then(() => {
              // 測試用 token 拿城市資料
              // 拿到 token 後
              if (myThis.isLogin) {
                console.log("islogin")
                // this.checkUserStatus().then(response => { alert(response)})
                if (myThis.user.emailVerified) {
                  console.log("myThis.user.emailVerified ok")
                  // 檢查用戶註冊狀態
                  myThis.checkUserStatus().then(response => {
                    initRemodal(() => {
                      console.log('initRemodal finish')
                      myThis.initRemodaled = true
                    })
                    if (myThis.isThirdParty !== 'password') myThis.userInfo.AvatarURL = user.providerData[0].photoURL
                    // 有完成註冊一跟 email 驗證才可以拿資料
                    // response.data.RegS1 = true
                    if (response.data.RegS1) {
                      myThis.userStage = userStatus.userStage2
                      myThis.getCurrentUserInfo().then((response)=> {
                        if (myThis.isThirdParty !== 'password' && typeof response.data === 'undefined' && typeof response.data.AvatarURL === 'undefined') {
                          myThis.userInfo.AvatarURL = user.providerData[0].photoURL
                        }
                      })
                      // // getUserInfo 無回應
                      myThis.getUserInfo()
                      // this.getUserAddress()
                      myThis.getUserWallet().then(response => {
                        // console.log(response.data.TongLi_Coin)
                        // console.log(this.cartList)
                        // console.log(`cartlist ${this.cartList}`)
                        // console.log(`is enough ${this.wallet.TongLi_Coin > this.cartList.TotalPrice}`)
                        // this.isEnoughShopping = this.wallet.TongLi_Coin > this.cartList.TotalPrice
                      })
                      resolve({
                        status: userStatus.userStage2,
                        user: user
                      })
                      if (!response.data.RegS2 && firebase.auth().currentUser.displayName=="y") {
                        window.location.hash="alert2"
                        firebase.auth().currentUser.updateProfile({
                          displayName:""
                        })
                      }
                      myThis.userStage = userStatus.userStage2
                    } else {
                      alert('請完成第一階段註冊資訊！')
                      window.location.hash = "notice1"
                      myThis.userStage = userStatus.userStage1
                      resolve({
                        status: userStatus.userStage1,
                        user: user
                      })
                      // reject(new Error('user need to finish s1 register'))
                    }
                  }).catch(function(e){
                    console.log("catch")
                    firebase.auth().currentUser.getIdToken(true).then(function(idToken) {
                      // myThis.redirectTo(`${window.location.origin}`)
                    })
                  })
                } else {
                  // this.getCities().then(response => {
                  //   response.data.map(res => {
                  //     this.getCountries(res.City)
                  //   })
                  // })
                  // alert('已寄送驗證信，請驗證信箱便於繼續瀏覽！')
                  console.log("!myThis.user.emailVerified")
                  console.log("")
                  resolve({
                    status: userStatus.emailValidate,
                    user: user
                  })
                  // myThis.userStage = userStatus.emailValidate
                  // myThis.sendEmailVerification(myThis.user)
                  // this.redirectTo(`${window.location.pathname}#notice2`)
                  // reject(new Error('user need to verify email'))
                  // if (window.location.pathname !== '/') this.redirectTo('/')
                  // this.redirectTo('/')
                }
              }
            })
          })
        } else {
          // No user is signed in.
          console.log('user is not login')
          resolve({
            status: userStatus.anonymous,
            user: user
          })
          // reject(new Error('user is not login'))
        }
      })
      // return firebase.auth().currentUser
      // return true
    })
  },
  checkUserStatus: function (cb) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/Account/RegStatus`, this.getBearerToken()).then(response => {
        // this.userStage = response
        // this.userStage = userStatus.userStage2
        resolve(response)
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
        reject(e)
      })
    })
  },
  getAccessToken: function (cb) {
    return new Promise((resolve, reject) => {
      firebase.auth().currentUser.getIdToken(false).then((accessToken) => {
        this.token = accessToken
        this.$cookie.set('token', this.token, { expires: '1Y' })
        // this.redirectTo('#')  0107註解FA
        resolve(accessToken)
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
        reject(e)
      })
    })
  },
  addOrRemoveLike: function (comment,event) {
    if(this.checkIsLogin()){
      if (comment.IsLike) {
        this.removeLike(comment)
      } else {
        this.addLike(comment)
      }
    }else{
      console.log("event",event)
      $(event.target).prop("checked",false)
      alert("請先登入!")
    }
  },
  removeLike: function (comment) {
    // console.log(this.register)
    // console.log(book)
    let params = {
      commentID: comment.ID
    }
    // console.log(params)
    axios.delete(`${API_URL}/Comment/Like/${this.$root.getParams(params, false)}`, this.$root.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      // console.log('subscribe/add')
      // console.log(response)
      // this.book.isSubscribe = response.data.Succeeded

      if (response.data.Succeeded) {
        console.log('comment/unlike')
        alert(`取消 ${comment.UserNickName} 的留言按讚成功`)
        if(this.comment.LikeCount > 0) this.comment.LikeCount--
      } else {
        alert(`${response.data.Errors[0].Message}`)
      }
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  addLike: function (comment) {
    // console.log(this.register)
    let params = {
      commentID: comment.ID
    }
    // console.log(params)
    axios.put(`${API_URL}/Comment/Like/${this.$root.getParams(params, false)}`, this.$root.getBodyFormData(params), this.$root.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      console.log('comment/like')
      if (response.data.Succeeded) {
        console.log('comment/like')
        alert(`按讚 ${comment.UserNickName} 的留言成功`)
        this.comment.LikeCount++
      } else {
        alert(`${comment.Errors[0].Message}`)
      }
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  checkIsLogin: function(){
    var user = firebase.auth().currentUser
    if(user!=null){
      return true
    }else{
      return false
    }
  },
  addOrRemoveSubscribe: function (book,event) {
    var userAgent = navigator.userAgent;
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera;
    var isEdge = userAgent.indexOf('Edge')> -1
    if(this.checkIsLogin()){
      if(isIE || isEdge){
        !book.IsSubscribe? this.removeSubscribe(book):this.addSubscribe(book)
      }else{
        book.IsSubscribe? this.removeSubscribe(book):this.addSubscribe(book)
      }
      // this.refreshList()
    }else{
      $(event.target).prop("checked",false)
      alert("請先登入!")

    }
  },
  addSubscribe: function (book) {
    let params = {
      bookGroupID: book.BookGroupID,
      IsSerial : book.IsSerial
    }
    axios.put(`${API_URL}/Subscribe`, this.$root.getBodyFormData(params), this.$root.getBearerToken()).then(response => {
      // this.book.isSubscribe = response.data.Succeeded
      if (response.data.Succeeded) {
        // isUndefined(book.Title)? alert(`${book.BookTitle} 追蹤成功`) : alert(`${book.Title} 追蹤成功`)
        // window.location.href = "/bookcase?sortType=5&apiType=1"
      } else {
        alert(`${response.data.Errors[0].Message}`)
      }
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  removeSubscribe: function (book) {
    let params = {
      bookGroupID: book.BookGroupID,
      IsSerial : book.IsSerial
    }
    axios.delete(`${API_URL}/Subscribe?BookGroupID=${book.BookGroupID}&IsSerial=${book.IsSerial}`, this.$root.getBearerToken()).then(response => {
      // console.log(response)
      if (response.data.Succeeded) {
        isUndefined(book.Title)? alert(`${book.BookTitle} 取消追蹤成功`) : alert(`${book.Title} 取消追蹤成功`)
      } else {
        alert(`${book.Errors[0].Message}`)
      }
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  getSubscribeList: function (sortType = 1, page = 1) {
    let params = {
      sortType: sortType,
      page: page
    }
    axios.get(`${API_URL}/Subscribe/List${this.getParams(params)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      // console.log(response)
      this.subscribeList = response.data
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  getIndexLastUpdate: function () {
    console.log('getIndexLastUpdate')
    // console.log(params)
    axios.post(`${API_URL}/Search/GetIndexLastUpdate`).then(response => {
      // JSON responses are automatically parsed.
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      alert(e.response.data.Errors[0].Message)
    })
  },
  search: function (SearchStr) {
    let params = {
      SearchStr: SearchStr
    }
    axios.post(`${API_URL}/Search`,this.getBodyFormData(params), this.getBearerToken()).then(response => {
      // console.log("search result",response)
      this.queryResult = response.data
      this.queryResult.searchStr = SearchStr
      this.queryResult.length===0 ? document.getElementById("queryResult").innerHTML="無任何搜尋結果" : ""
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // alert(e.response.data.Errors[0].Message)
    })
  },
  getQAList: function () {
    axios.get(`${API_URL}/QA/QAList`).then(response => {
      // JSON responses are automatically parsed.
      // console.log(response)
      this.QALists = response.data
    }).catch(e => {
      console.log(e)
      // this.errors.push(e)
      // alert(e.response.data.Errors[0].Message)
    })
  },
  selectCity: function () {
    this.selectedCity = this.register.city
  },
  filesChange (name, file) {
    this.loadFile(name, file[0])
    this.editUserAvatar(name, file[0])
    // console.log('filesChange')
    // console.log(name)
    // console.log(file)
  },
  loadFile (name, file) {
    let reader  = new FileReader();

    /*
      Add an event listener to the reader that when the file
      has been loaded, we flag the show preview as true and set the
      image to be what was read from the reader.
    */
  console.log('reader.addEventListener')
    reader.addEventListener("load", () => {
      // this.showPreview = true;
      console.log('reader.addEventListener loaded')
      this.userInfo.AvatarURL = reader.result;
    }, false);
    /*
      Check to see if the file is not empty.
    */
    if(file){
      /*
        Ensure the file is an image file.
      */
      if ( /\.(jpe?g|png|gif)$/i.test( file.name ) ) {
        /*
          Fire the readAsDataURL method which will read the file in and
          upon completion fire a 'load' event which we will listen to and
          display the image in the preview.
        */
        reader.readAsDataURL( file );
      }
    }
  },
  uploadAvatar () {
    document.getElementById("avatar").click()
  },
  getStageName (lists, id) {
    return lists.filter(list => list.ID === id)[0].Name
  },
  //0918火力新增
  hideShowPsw () {
    this.pwVisible = !this.pwVisible
  },
  //FB已被註冊
  checkFacebookAccount(){
    const thisItem = this
    window.location.hash = ""
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then((result) => {
      let loginEmail = thisItem.fbCheck.email
      let loginPassword = thisItem.fbCheck.password
      return firebase.auth().signInWithEmailAndPassword(loginEmail, loginPassword).then((result) => {
        console.log("login success!")
        if(thisItem.fbCheck.credential){
          var cred = firebase.auth.FacebookAuthProvider.credential(thisItem.fbCheck.credential.accessToken);
          // var provider = providerFacebook;
          // var user = firebase.auth().currentUser;
          firebase.auth().currentUser.linkAndRetrieveDataWithCredential(cred).then(function(response){
              alert("綁定成功")
          }).catch(function(e){
            console.log(e)
            alert("綁定失敗")
            window.location.hash = "notice3"
          })
          // user.linkWithRedirect(provider).then(function(res){
          //   alert("綁定成功")
          //   console.log(res)
          //   // thisItem.redirectTo(`${window.location.origin}#alert3`)
          // }).catch(function(e){
          //   alert("綁定失敗")
          //   window.location.hash = "notice3"
          // })
        }else{
          console.log("credential empty")
        }
      }).catch(function (e) {
        console.log(e)
        if(e.code == "auth/wrong-password"){
          alert("登入失敗：密碼錯誤")
        }else{
          alert("登入失敗：帳號錯誤或尚未註冊")
        }
        window.location.hash = "notice3"
      })
    }).catch(function (e) {
      alert(e.response.data.Errors[0].Message.message)
      window.location.hash = "notice3"
    })
  }
}



// WEBPACK FOOTER //
// ./src/user.js